/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateNftGroupingBody
 */
export interface UpdateNftGroupingBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateNftGroupingBody
     */
    groupingId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateNftGroupingBody
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateNftGroupingBody
     */
    sortPriority?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateNftGroupingBody
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateNftGroupingBody
     */
    discordUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateNftGroupingBody
     */
    twitterUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateNftGroupingBody
     */
    websiteUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateNftGroupingBody
     */
    hero?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateNftGroupingBody
     */
    icon?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateNftGroupingBody
     */
    categories?: Array<string>;
}

export function UpdateNftGroupingBodyFromJSON(json: any): UpdateNftGroupingBody {
    return UpdateNftGroupingBodyFromJSONTyped(json, false);
}

export function UpdateNftGroupingBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateNftGroupingBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'groupingId': json['groupingId'],
        'name': json['name'],
        'sortPriority': !exists(json, 'sortPriority') ? undefined : json['sortPriority'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'discordUrl': !exists(json, 'discordUrl') ? undefined : json['discordUrl'],
        'twitterUrl': !exists(json, 'twitterUrl') ? undefined : json['twitterUrl'],
        'websiteUrl': !exists(json, 'websiteUrl') ? undefined : json['websiteUrl'],
        'hero': !exists(json, 'hero') ? undefined : json['hero'],
        'icon': !exists(json, 'icon') ? undefined : json['icon'],
        'categories': !exists(json, 'categories') ? undefined : json['categories'],
    };
}

export function UpdateNftGroupingBodyToJSON(value?: UpdateNftGroupingBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'groupingId': value.groupingId,
        'name': value.name,
        'sortPriority': value.sortPriority,
        'description': value.description,
        'discordUrl': value.discordUrl,
        'twitterUrl': value.twitterUrl,
        'websiteUrl': value.websiteUrl,
        'hero': value.hero,
        'icon': value.icon,
        'categories': value.categories,
    };
}


